import {IDynamicFieldsElementOptions} from "../../../interfaces/dynamicFieldsElementOptionsInterfaces";

export default abstract class DynamicFieldsElementOptions<E, C> {
  abstract getElements: (container: C) => E[];
  abstract getElementsDefault(container: C): E[];
  abstract matcher: (element: E) => boolean;
  abstract matcherDefault(element: E): boolean;
  abstract matchElements(container: C, q: string): E[];

  protected constructor(config: Partial<IDynamicFieldsElementOptions<E, C>> = {getElements: null, matcher: null}) {
    this.initialize(config);
  }

  protected initialize(config: Partial<IDynamicFieldsElementOptions<E, C>> = {getElements: null, matcher: null}) {
    this.matcher = config.matcher || this.matcherDefault;
    this.getElements = config.getElements || this.getElementsDefault;
  }
}